import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Logo from "../assets/Logo.png";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as UserIcon } from "../images/ab (6).svg";
import { ReactComponent as UserIcon1 } from "../images/ab (2).svg";
import { ReactComponent as UserIcon2 } from "../images/ab (3).svg";
import { ReactComponent as UserIcon3 } from "../images/ab (1).svg";
import { ReactComponent as UserIcon4 } from "../images/ab (4).svg";
import { ReactComponent as UserIcon5 } from "../images/ab (5).svg";
import { ReactComponent as UserIcon6 } from "../assets/mobile.svg";
import { ReactComponent as UserIcon7 } from "../assets/electricity.svg";
import { ReactComponent as UserIcon8 } from "../assets/fastag.svg";
import { ReactComponent as UserIcon9 } from "../assets/dth.svg";
import { ReactComponent as UserIcon10 } from "../assets/water.svg";
import { ReactComponent as UserIcon11 } from "../assets/health.svg";
import { ReactComponent as UserIcon12 } from "../assets/life.svg";
import { ReactComponent as UserIcon13 } from "../assets/travel.svg";
import { ReactComponent as UserIcon14 } from "../assets/pipe.svg";
import { ReactComponent as UserIcon16 } from "../images/Gold Loan.svg";
import { ReactComponent as UserIcon17 } from "../images/Business Loan-01.svg";
import { ReactComponent as UserIcon18 } from "../images/Medical Loan-01.svg";
import { ReactComponent as UserIcon20 } from "../assets/gadget.svg";
import { ReactComponent as UserIcon21 } from "../assets/business.svg";
import { ReactComponent as UserIcon22 } from "../assets/cable.svg";
import { ReactComponent as UserIcon23 } from "../assets/broadbandtv.svg";
import { ReactComponent as UserIcon24 } from "../assets/gas.svg";
import { ReactComponent as UserIcon25 } from "../assets/home.svg";

const Navbar = () => {
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    const handleScroll = () => setScrolled(window.scrollY > 20);

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    handleResize();
    handleScroll();
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleNavItemClick = () => {
    if (isMobile) {
      setExpanded(false);
    }
  };

  const toggleSearch = () => {
    setShowSearch(!showSearch);
    if (showSearch) {
      setSearchTerm("");
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const processSearch = () => {
    console.log("processSearch called with:", searchTerm);

    if (!searchTerm.trim()) {
      console.log("Empty search term");
      return;
    }

    const term = searchTerm.toLowerCase().trim();
    console.log("Processing term:", term);

    let targetPage = "/";

    if (term.includes("credit card")) {
      targetPage = "/credit-card";
      console.log("Matched: credit card -> /credit-card");
    } else if (term.includes("car insurance")) {
      targetPage = "/carinsurance";
      console.log("Matched: car insurance -> /carinsurance");
      console.log("Search term:", term, "Type:", typeof term);
    } else if (term.toLowerCase().includes("mobile")) {
      targetPage = "/mobileprepaid";
      console.log("Matched: mobile -> /mobile");
    } else if (term.includes("bike insurance")) {
      targetPage = "/bikeinsurance";
      console.log("Matched: bike insurance -> /bikeinsurance");
    } else if (term.includes("travel insurance")) {
      targetPage = "/travelinsurance";
      console.log("Matched: travel insurance -> /travelinsurance");
    } else if (term.includes("life insurance")) {
      targetPage = "/lifeinsurance";
      console.log("Matched: life insurance -> /lifeinsurance");
    } else if (term.includes("health insurance")) {
      targetPage = "/healthinsurance";
      console.log("Matched: health insurance -> /healthinsurance");
    } else if (term.includes("home insurance")) {
      targetPage = "/home";
      console.log("Matched: home insurance -> /home");
    } else if (term.includes("business loan")) {
      targetPage = "/businessloan";
      console.log("Matched: business loan -> /businessloan");
    } else if (term.includes("education loan")) {
      targetPage = "/educationloan";
      console.log("Matched: education loan -> /educationloan");
    } else if (term.includes("home loan")) {
      targetPage = "/homeloan";
      console.log("Matched: home loan -> /homeloan");
    } else if (term.includes("bike loan")) {
      targetPage = "/bikeloan";
      console.log("Matched: bike loan -> /bikeloan");
    } else if (term.includes("car loan")) {
      targetPage = "/carloan";
      console.log("Matched: car loan -> /carloan");
    } else if (
      term.includes("preapprove loan") ||
      term.includes("pre approve loan") ||
      term.includes("preapproveloan")
    ) {
      targetPage = "/preapproveLoan";
      console.log("Matched: preapprove loan -> /preapproveLoan");
    } else if (term.includes("loan") || term.includes("credit")) {
      targetPage = "/allTypeloan";
      console.log("Matched: general loan -> /allTypeloan");
    } else if (term.includes("insurance") || term.includes("coverage")) {
      targetPage = "/alltypeinsurance";
      console.log("Matched: general insurance -> /alltypeinsurance");
    } else if (term.includes("payment") || term.includes("pay")) {
      targetPage = "/alltypepayment";
      console.log("Matched: payment -> /alltypepayment");
    } else if (term.includes("about") || term.includes("company")) {
      targetPage = "/about";
    } else if (term.includes("blog")) {
      targetPage = "/all-blogs";
    } else if (term.includes("contact")) {
      targetPage = "/contact-us";
    } else if (term.includes("career")) {
      targetPage = "/career";
    } else if (term.includes("track")) {
      targetPage = "/track";
    } else if (term.includes("emi")) {
      targetPage = "/EMIPAGE";
    } else if (term.includes("modal")) {
      targetPage = "/modal";
    } else if (term.includes("privacy")) {
      targetPage = "/privacy";
    } else if (term.includes("term")) {
      targetPage = "/term";
    } else if (term.includes("job")) {
      targetPage = "/jobmodal";
    } else if (term.includes("individual")) {
      targetPage = "/Individualservice";
    } else if (term.includes("mobileprepaid")) {
      targetPage = "/mobileprepaid";
    // } else if (term.includes("mobilepostpaid")) {
    //   targetPage = "/mobilepostpaid";
    } else if (term.includes("dth")) {
      targetPage = "/dth";
    } else if (term.includes("water")) {
      targetPage = "/water";
    } else if (term.includes("electricity")) {
      targetPage = "/electricity";
    } else if (term.includes("fastag")) {
      targetPage = "/fastag";
    } else if (term.includes("gold")) {
      targetPage = "/gold";
    } else if (term.includes("property")) {
      targetPage = "/property";
    } else if (term.includes("medical")) {
      targetPage = "/medical";
    } else if (term.includes("gadget")) {
      targetPage = "/gadget";
    } else if (term.includes("business")) {
      targetPage = "/business";
    } else if (term.includes("pipe")) {
      targetPage = "/pipe";
    } else if (term.includes("cable") || term.includes("wire")) {
      targetPage = "/cablewire";
    } else if (term.includes("broadband")) {
      targetPage = "/broadband";
    } else if (term.includes("gas")) {
      targetPage = "/gas";
    } else if (term.includes("home")) {
      targetPage = "/home";
    } else {
      console.log("No match found, staying on home");
    }
    console.log("Final target page:", targetPage);

    try {
      navigate(targetPage);
      console.log("Navigation successful to:", targetPage);
    } catch (error) {
      console.error("Navigation failed:", error);
    }

    setSearchTerm("");
    setShowSearch(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      processSearch();
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    processSearch();
  };

  const handleSearchIconClick = () => {
    if (showSearch && searchTerm.trim()) {
      processSearch();
    } else {
      toggleSearch();
    }
  };

  const [dropdownStates, setDropdownStates] = useState({
  loansDropdown: false,
  insuranceDropdown: false,
  paymentsDropdown: false,
});

const toggleDropdown = (e, dropdownId) => {
  e.preventDefault();
  e.stopPropagation();
  
  setDropdownStates(prevStates => ({
    loansDropdown: false,
    insuranceDropdown: false,
    paymentsDropdown: false,
    [dropdownId]: !prevStates[dropdownId]
  }));
};

useEffect(() => {
  const handleScroll = () => {
    if (window.scrollY > 10) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  window.addEventListener("scroll", handleScroll);
  
  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);
  return (
    <>
      {!isMobile && (
        <nav
          className={`navbar navbar-expand-lg navbar-light ${
            isScrolled ? "" : "rounded-pill"
          }`}
          style={{
            position: "fixed",
            // top: "1.5rem",
            top: isScrolled ? "0" : "1.5rem",
            left: "50%",
            transform: "translateX(-50%)",
            width: isScrolled ? "100%" : "92%",
            maxWidth: isScrolled ? "100%" : "70rem",
            zIndex: 1000,
            padding: "1rem",
            transition: "all 0.3s ease",
            borderRadius: isScrolled ? "0" : "",
            backgroundColor: " #E7EFFF",
          }}
        >
          <div className="container">
            <Link className="navbar-brand fw-bold" to="/">
              <img
                src={Logo}
                alt="ShubhPaisa Logo"
                style={{ height: "50px", backgroundColor: "none" }}
              />
            </Link>

            <div className="d-flex align-items-center justify-content-center ">
              <div
                className="custom-dropdown"
                style={{ position: "relative", display: "inline-block" }}
              >
                <Link
                  to="/alltypeloan"
                  className="fw-semibold text-black text-decoration-none mx-2 py-2 "
                  style={{ display: "flex", alignItems: "center" }}
                >
                  Loans
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-chevron-down ms-1"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </Link>

                <div
                  className="custom-dropdown-content border-0 rounded-4 "
                  style={{
                    width: "1080px",
                    left: "-31.40rem",
                    top: "100%",
                    padding: 0,
                    border: "none",
                    position: "absolute",
                    borderToprightRadius: "20px",
                    borderBottomLeftRadius: "20px",
                  }}
                >
                  <div className="row rounded-3">
                    <div
                      className="col-md-3 col-12 d-flex align-items-center bg-light"
                      style={{
                        // backgroundColor: " #ffffff",
                        color: " #4B4B4B",
                        height: "11rem",
                        borderTopLeftRadius: "20px",
                        borderBottomLeftRadius: "20px",
                      }}
                    >
                      <div className="w-100 ">
                        <h5
                          className="fw-bold text-center"
                          style={{ color: "#0f62fe" }}
                        >
                          Loan for<br></br>
                          <span>Everyone</span>
                        </h5>
                      </div>
                    </div>

                    <div
                      className="col-md-9 col-12 bg-white p-3 m-auto"
                      style={{
                        height: "11rem",
                        width: "75%",
                        borderTopRightRadius: "15px",
                        borderBottomRightRadius: "15px",
                      }}
                    >
                      <div
                        className="row mt-3"
                        style={{ marginLeft: "0.5rem" }}
                      >
                        <div className="col-6 col-md-4 mb-2">
                          <Link
                            to="/Individualservice"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Personal Loan
                          </Link>
                        </div>
                        <div className="col-6 col-md-4 mb-2">
                          <Link
                            to="/homeloan"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon1
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Home Loan
                          </Link>
                        </div>
                        <div className="col-6 col-md-4 mb-2">
                          <Link
                            to="/carloan"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon2
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Car Loan
                          </Link>
                        </div>

                        <div className="col-6  mt-2 col-md-4  mb-2">
                          <Link
                            to="/educationloan"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon3
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Education Loan
                          </Link>
                        </div>
                        <div className="col-6  mt-2 col-md-4 mb-2">
                          <Link
                            to="/bikeloan"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon4
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Bike Loan
                          </Link>
                        </div>

                        <div className="col-6 mt-2 col-md-4 mb-2">
                          <Link
                            to="/businessloan"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon5
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Business Loan
                          </Link>
                        </div>

                        <div className="col-6   mt-2 col-md-4 mb-2">
                          <Link
                            to="/gold"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon16
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Gold Loan
                          </Link>
                        </div>

                        <div className="col-6   mt-2 col-md-4 mb-2">
                          <Link
                            to="/property"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon17
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Property Loan
                          </Link>
                        </div>

                        <div className="col-6   mt-2 col-md-4 mb-2">
                          <Link
                            to="/medical"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon18
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Medical Loan
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="custom-dropdown"
                style={{ position: "relative", display: "inline-block" }}
              >
                <Link
                  to="/alltypeinsurance"
                  className="fw-semibold text-black text-decoration-none mx-2 py-2"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  Insurance
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-chevron-down ms-1"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </Link>
                <div
                  className="custom-dropdown-content rounded-4  border-0 "
                  style={{
                    width: "1080px",
                    left: "-36.60rem",
                    top: "100%",
                    padding: 0,
                    border: "none",
                  }}
                >
                  <div className="row rounded-3">
                    <div
                      className="col-md-3 col-12  p-3 d-flex align-items-center bg-light"
                      style={{
                        height: "11rem",
                        borderTopLeftRadius: "20px",
                        borderBottomLeftRadius: "20px",
                      }}
                    >
                      <div className="w-100 ">
                        <h5
                          className="fw-bold text-center"
                          style={{ color: "#0f62fe" }}
                        >
                          Insurance for<br></br>
                          <span>Everyone</span>
                        </h5>
                      </div>
                    </div>

                    <div
                      className="col-md-9 col-12 bg-white p-3 m-auto"
                      style={{
                        height: "11rem",
                        width: "75%",
                        borderTopRightRadius: "15px",
                        borderBottomRightRadius: "15px",
                      }}
                    >
                      <div
                        className="row mt-3"
                        style={{ marginLeft: "0.5rem" }}
                      >
                        <div className="col-6 col-md-4 mb-2">
                          <Link
                            to="/home"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon25
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Home Insurance
                          </Link>
                        </div>
                        <div className="col-6 col-md-4 mb-2">
                          <Link
                            to="/healthinsurance"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon11
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Health Insurance
                          </Link>
                        </div>
                        <div className="col-6 col-md-4 mb-2">
                          <Link
                            to="/lifeinsurance"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon12
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Life Insurance
                          </Link>
                        </div>
                        <div className="col-6 mt-2 col-md-4 mb-2">
                          <Link
                            to="/travelinsurance"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon13
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Travel Insurance
                          </Link>
                        </div>
                        <div className="col-6  mt-2 col-md-4 mb-2">
                          <Link
                            to="/bikeinsurance"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon4
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Bike Insurance
                          </Link>
                        </div>
                        <div className="col-6  mt-2 col-md-4 mb-2">
                          <Link
                            to="/carinsurance"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon2
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Car Insurance
                          </Link>
                        </div>

                        <div className="col-6 col-md-4 mb-2 mt-2">
                          <Link
                            to="/gadget"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon20
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Gadget Insurance
                          </Link>
                        </div>

                        <div className="col-6 col-md-4 mb-2 mt-2">
                          <Link
                            to="/business"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon21
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Business Insurance
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="custom-dropdown"
                style={{ position: "relative", display: "inline-block" }}
              >
                <Link
                  to="/alltypepayment"
                  className="fw-semibold text-black text-decoration-none mx-2 py-2"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  Payment
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-chevron-down ms-1"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                    />
                  </svg>
                </Link>
                <div
                  className="custom-dropdown-content rounded-4  border-0 "
                  style={{
                    width: "1080px",
                    left: "-43.95rem",
                    top: "100%",
                    padding: 0,
                    border: "none",
                  }}
                >
                  <div className="row rounded-3">
                    <div
                      className="col-md-3 col-12  p-3 d-flex align-items-center bg-light"
                      style={{
                        // backgroundColor: "#ffffff",
                        color: "#4B4B4B",
                        height: "11rem",
                        borderTopLeftRadius: "20px",
                        borderBottomLeftRadius: "20px",
                      }}
                    >
                      <div className="w-100 ">
                        <h5
                          className="fw-bold text-center"
                          style={{ color: "#0f62fe" }}
                        >
                          Payment for<br></br>
                          <span>Everyone</span>
                        </h5>
                      </div>
                    </div>

                    <div
                      className="col-md-9 col-12 bg-white p-3 m-auto"
                      style={{
                        height: "11rem",
                        width: "75%",
                        borderTopRightRadius: "15px",
                        borderBottomRightRadius: "15px",
                      }}
                    >
                      <div
                        className="row mt-3"
                        style={{ marginLeft: "0.5rem" }}
                      >
                        <div className="col-6 col-md-4 mb-2">
                          <Link
                            to="/mobileprepaid"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon6
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Mobile Recharge
                          </Link>
                        </div>
                        <div className="col-6 col-md-4 mb-2">
                          <Link
                            to="/dth"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon9
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Dth Recharge
                          </Link>
                        </div>
                        <div className="col-6 col-md-4 mb-2">
                          <Link
                            to="/electricity"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon7
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Electricity Recharge
                          </Link>
                        </div>
                        <div className="col-6  mt-2 col-md-4 mb-2">
                          <Link
                            to="/fastag"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon8
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Fastag Recharge
                          </Link>
                        </div>
                        <div className="col-6  mt-2 col-md-4 mb-2">
                          <Link
                            to="/water"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon10
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Water Bill
                          </Link>
                        </div>

                        <div className="col-6 mt-2 col-md-4 mb-2">
                          <Link
                            to="/pipe"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon14
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Pipe Line Gas
                          </Link>
                        </div>

                        <div className="col-6  mt-2 col-md-4 mb-2">
                          <Link
                            to="/cablewire"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon22
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Cable Recharge
                          </Link>
                        </div>

                        <div className="col-6 mt-2 col-md-4 mb-2">
                          <Link
                            to="/broadband"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon23
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Broadband
                          </Link>
                        </div>
                        <div className="col-6  mt-2 col-md-4 mb-2">
                          <Link
                            to="/gas"
                            className="dropdown-item d-flex align-items-center"
                          >
                            <UserIcon24
                              className="me-2"
                              style={{ width: "25px", height: "25px" }}
                            />
                            Gas Cylindar
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Link
                to="/about"
                className="fw-semibold text-black text-decoration-none mx-2 me-4 py-2 fs-6"
              >
                About Us
              </Link>

              <div className="d-none d-lg-flex align-items-center mt-3 mt-lg-0 mb-3 mb-lg-0 me-2 ">
                <div className="search-container">
                  <form onSubmit={handleSearchSubmit} className="search-form">
                    <input
                      type="text"
                      className={`search-input ${showSearch ? "show" : ""}`}
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                      aria-label="Search"
                    />
                    <button
                      type="button"
                      className="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "35px", height: "35px" }}
                      onClick={handleSearchIconClick}
                      aria-label={showSearch ? "Perform search" : "Show search"}
                    >
                      <i
                        className={`fas ${
                          showSearch && searchTerm.trim()
                            ? "fa-search"
                            : showSearch
                            ? "fa-times"
                            : "fa-search"
                        }`}
                        style={{ fontSize: "1.1rem", color: "#4B4B4B" }}
                      ></i>
                    </button>
                  </form>
                </div>
                <button
                  className="btn btn-light rounded-circle d-flex align-items-center justify-content-center position-relative"
                  style={{
                    width: "35px",
                    height: "35px",
                    padding: "0",
                    marginLeft: "0.9rem",
                  }}
                >
                  <i
                    className="fas fa-bell"
                    style={{ fontSize: "1.1rem", color: "#4B4B4B" }}
                  ></i>
                  <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger notification-badge"
                    style={{ fontFamily: "Poppins" }}
                  ></span>
                </button>
              </div>

              <div className="d-flex gap-2">
                <button
                  className="btn fw-bold rounded-pill p-0 "
                  style={{ fontFamily: "poppins", marginLeft: "0.8rem" }}
                >
                  Login
                </button>
                {/* <button className="btn btn-primary rounded-pill">Sign Up</button> */}
              </div>
            </div>
          </div>
        </nav>
      )}

      {isMobile && (
        <nav
          className="navbar m-auto rounded-5"
          style={{
            width: "100%",
            maxWidth: "95%",
            minWidth: "280px",
            backgroundColor: "#E7EFFF",
            position: "fixed",
            top: "30px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1000,
          }}
        >
          <div className="container w-100 p-2">
            <Link className="navbar-brand fw-bold mx-2" to="/">
              <img
                src={Logo}
                alt="ShubhPaisa Logo"
                style={{ height: "35px", backgroundColor: "none" }}
              />
            </Link>

            <div className="d-flex align-items-center mt-2 mx-3">
              <div className="d-flex align-items-center">
                <form
                  onSubmit={handleSearchSubmit}
                  className="d-flex align-items-center position-relative"
                >
                  <input
                    type="text"
                    className={`form-control rounded-pill me-0 ${
                      showSearch ? "d-inline-block" : "d-none"
                    }`}
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    aria-label="Search"
                    style={{
                      width: showSearch ? "140px" : "0",
                      transition: "width 0.3s",
                    }}
                  />
                  <button
                    type="button"
                    className="btn p-1 position-relative"
                    onClick={handleSearchIconClick}
                    aria-label="Search button"
                  >
                    <i
                      className={`fas ${
                        showSearch && searchTerm.trim()
                          ? "fa-search"
                          : showSearch
                          ? "fa-times"
                          : "fa-search"
                      }`}
                      style={{ fontSize: "1rem", color: "#4B4B4B" }}
                    ></i>
                  </button>
                </form>
              </div>

              <button className="btn p-1 ms-2 position-relative">
                <i
                  className="fas fa-bell"
                  style={{ fontSize: "1rem", color: "#4B4B4B" }}
                ></i>
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger notification-badge"></span>
              </button>

              <button
                className="navbar-toggler ms-4"
                type="button"
                onClick={() => setExpanded(!expanded)}
              >
                <span
                  className="navbar-toggler-icon"
                  style={{ fontSize: "14px" }}
                ></span>
              </button>
            </div>

            <div
              className={`collapse navbar-collapse ${expanded ? "show" : ""}`}
            >
              <div
                className="d-flex flex-column gap-3 align-items-start w-100 px-3 mt-4 mb-2"
                style={{ fontSize: "15px", fontFamily: "Poppins, sans-serif" }}
              >
                <div className="dropdown w-100 position-static mb-2">
                  <button
                    className="btn w-100 text-start fw-semibold d-flex justify-content-between align-items-center py-2"
                    type="button"
                    id="loansDropdown"
                    onClick={(e) => toggleDropdown(e, "loansDropdown")}
                    aria-expanded={
                      dropdownStates.loansDropdown ? "true" : "false"
                    }
                    style={{
                      color: "#4B4B4B",
                      fontFamily: "Poppins, sans-serif",
                    }}
                  >
                    <Link to="/allTypeloan" style={{ textDecoration: "none" }}>
                      <span
                        style={{
                          cursor: "pointer",
                          color: "#4b4b4b",
                          fontFamily: "Poppins",
                        }}
                      >
                        Loans
                      </span>
                    </Link>

                    <i
                      className={`fas ${
                        dropdownStates.loansDropdown
                          ? "fa-chevron-up"
                          : "fa-chevron-down"
                      }`}
                    ></i>
                  </button>
                  {dropdownStates.loansDropdown && (
                    <div className="mt-3 "></div>
                  )}
                  <ul
                    className={`dropdown-menu w-100 position-static mt-2 ${
                      dropdownStates.loansDropdown ? "show" : ""
                    }`}
                    aria-labelledby="loansDropdown"
                    style={{
                      maxHeight: dropdownStates.loansDropdown ? "300px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.3s ease-in-out",
                      border: dropdownStates.loansDropdown
                        ? "1px solid rgba(0,0,0,0.15)"
                        : "none",
                      borderRadius: "0.25rem",
                      padding: dropdownStates.loansDropdown ? "0.5rem 0" : "0",
                      marginTop: dropdownStates.loansDropdown ? "0.5rem" : "0",
                    }}
                  >
                    <div className="">
                      <li>
                        <Link
                          className="dropdown-item "
                          to="/Individualservice"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Personal Loan
                        </Link>
                      </li>

                      <li>
                        <Link
                          className="dropdown-item"
                          to="/homeloan"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Home Loan
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/carloan"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Car Loan
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/bikeloan"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Bike Loan
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/businessloan"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Business Loan
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/educationloan"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Education Loan
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/gold"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Gold Loan
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/property"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Property Loan
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/medical"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Medical Loans
                        </Link>
                      </li>
                    </div>
                  </ul>
                </div>

                <div className="dropdown w-100 position-static mb-2">
                  <button
                    className="btn w-100 text-start fw-semibold d-flex justify-content-between align-items-center py-2"
                    type="button"
                    id="insuranceDropdown"
                    onClick={(e) => toggleDropdown(e, "insuranceDropdown")}
                    aria-expanded={
                      dropdownStates.insuranceDropdown ? "true" : "false"
                    }
                    style={{
                      color: "#4B4B4B",
                      fontFamily: "Poppins, sans-serif",
                    }}
                  >
                    <Link
                      to="/alltypeinsurance"
                      style={{ textDecoration: "none" }}
                    >
                      <span
                        style={{
                          cursor: "pointer",
                          color: "#4b4b4b",
                          fontFamily: "Poppins",
                        }}
                      >
                        Insurance
                      </span>
                    </Link>
                    <i
                      className={`fas ${
                        dropdownStates.insuranceDropdown
                          ? "fa-chevron-up"
                          : "fa-chevron-down"
                      }`}
                    ></i>
                  </button>
                  {dropdownStates.insuranceDropdown && (
                    <div className="mt-3"></div>
                  )}
                  <ul
                    className={`dropdown-menu w-100 position-static mt-2 ${
                      dropdownStates.insuranceDropdown ? "show" : ""
                    }`}
                    aria-labelledby="insuranceDropdown"
                    style={{
                      maxHeight: dropdownStates.insuranceDropdown
                        ? "300px"
                        : "0",
                      overflow: "hidden",
                      transition: "max-height 0.3s ease-in-out",
                      border: dropdownStates.insuranceDropdown
                        ? "1px solid rgba(0,0,0,0.15)"
                        : "none",
                      borderRadius: "0.25rem",
                      padding: dropdownStates.insuranceDropdown
                        ? "0.5rem 0"
                        : "0",
                      marginTop: dropdownStates.insuranceDropdown
                        ? "0.5rem"
                        : "0",
                    }}
                  >
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/home"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Home Insurance
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/lifeinsurance"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Life Insurance
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/healthinsurance"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Health Insurance
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/bikeinsurance"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Bike Insurance
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/carinsurance"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Car Insurance
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/travelinsurance"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Travel Insurance
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/gadget"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Gadget Insurance
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/business"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Business Insurance
                        </Link>
                      </li>
                    
                  </ul>
                </div>

                <div className="dropdown w-100 position-static mb-2">
                  <button
                    className="btn w-100 text-start fw-semibold d-flex justify-content-between align-items-center py-2"
                    type="button"
                    id="paymentsDropdown"
                    onClick={(e) => toggleDropdown(e, "paymentsDropdown")}
                    aria-expanded={
                      dropdownStates.paymentsDropdown ? "true" : "false"
                    }
                    style={{
                      color: "#4B4B4B",
                      fontFamily: "Poppins, sans-serif",
                    }}
                  >
                    <Link
                      to="/alltypepayment"
                      style={{ textDecoration: "none" }}
                    >
                      <span
                        style={{
                          cursor: "pointer",
                          color: "#4b4b4b",
                          fontFamily: "Poppins",
                        }}
                      >
                        Payment
                      </span>
                    </Link>
                    <i
                      className={`fas ${
                        dropdownStates.paymentsDropdown
                          ? "fa-chevron-up"
                          : "fa-chevron-down"
                      }`}
                    ></i>
                  </button>
                  {dropdownStates.paymentsDropdown && (
                    <div className="mt-3"></div>
                  )}
                  <ul
                    className={`dropdown-menu w-100 position-static mt-2 ${
                      dropdownStates.paymentsDropdown ? "show" : ""
                    }`}
                    aria-labelledby="paymentsDropdown"
                    style={{
                      maxHeight: dropdownStates.paymentsDropdown
                        ? "340px"
                        : "0",
                      overflow: "hidden",
                      transition: "max-height 0.3s ease-in-out",
                      border: dropdownStates.paymentsDropdown
                        ? "1px solid rgba(0,0,0,0.15)"
                        : "none",
                      borderRadius: "0.25rem",
                      padding: dropdownStates.paymentsDropdown
                        ? "0.5rem 0"
                        : "0",
                      marginTop: dropdownStates.paymentsDropdown
                        ? "0.5rem"
                        : "0",
                    }}
                  >
                    <div className="">
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/mobileprepaid"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Mobile Recharge
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/dth"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Dth Recharge
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/electricity"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Electricity Recharge
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/fastag"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Fastag Recharge
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/water"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Water Bill
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/pipe"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Pipe Line Gas
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/cablewire"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Cable Recharge
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/broadband"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Broadband Recharge
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/gas"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Gas Cylindar
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/credit-card"
                          style={{
                            color: "#4B4B4B",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Creditcard Bill
                        </Link>
                      </li>
                    </div>
                  </ul>
                </div>

                <Link
                  to="/about"
                  onClick={handleNavItemClick}
                  className="fw-semibold text-decoration-none mx-1 px-2"
                  style={{
                    color: "#4B4B4B",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  About Us
                </Link>

                <div className="mt-1">
                  <button
                    className="btn fw-semibold w-50"
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      color: "#4B4B4B",
                    }}
                  >
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </nav>
      )}
    </>
  );
};

export default Navbar;
